/**
 * Đổi HTML của editor thành text thuần (1 dòng).
 *
 * Subject của email là HTTP header nên KHÔNG chứa được HTML — template subject lại được
 * soạn bằng SunEditor nên giá trị lưu ra là '<p>xin chào&nbsp;<span ...>...</span></p>'.
 * Nếu dùng thẳng thì user thấy code HTML trên preview và email gửi đi cũng mang nguyên
 * đống thẻ đó ở tiêu đề.
 */
export const htmlToPlainText = (html) => {
    if (!html) return '';

    return String(html)
        // Thẻ ngắt dòng/khối -> khoảng trắng, tránh 2 dòng bị dính liền thành một từ
        .replace(/<\s*br\s*\/?\s*>/gi, ' ')
        .replace(/<\s*\/\s*(p|div|li|tr|h[1-6])\s*>/gi, ' ')
        // Bỏ mọi thẻ còn lại, gồm cả <span class="se-custom-tag"> do plugin Add fields sinh ra
        .replace(/<[^>]*>/g, '')
        // Giải mã entity hay gặp. &amp; phải để CUỐI, nếu không '&amp;lt;' sẽ bị giải mã 2 lần thành '<'
        .replace(/&nbsp;|&#0*160;|&#x0*a0;/gi, ' ')
        .replace(/&quot;/gi, '"')
        .replace(/&apos;|&#0*39;/gi, "'")
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&amp;/gi, '&')
        .replace(/[\u200B\u200C\u200D\uFEFF]/g, '')   // zero-width
        .replace(/[\u00A0\u2007\u202F]/g, ' ')         // nbsp dạng ký tự
        .replace(/\s+/g, ' ')
        .trim();
};

export const concatStrings = (str1, str2, char = ";") => {
    if (str1 && str2) {
        return str1.concat(char, str2);
    }

    if (str1) {
        return str1
    }
    if (str2) {
        return str2
    }

    return ""
}